import React, { useState } from 'react'
import { request_rsvp_otp, verify_rsvp_otp } from '../../api/event';
import { toast } from 'react-toastify';
import { getWithExpiry, setWithExpiry } from '../../utils/storage';
import { useNavigate } from 'react-router-dom';
import { sleep } from '../OnbaordingForm/OnboardingForm';

export default function AuthRSVPManager(props) {
  const navigate = useNavigate()

  const [isSubmitting, setIsSubmitting] = useState(false)
  const [loading, setLoading] = useState(false)
  const [dataFetchFailed, setDataFetchFailed] = useState(false)
  const [tempId, setTempId] = useState("");
  const [displayType, setDisplayType] = useState("email-input")

  const [inputValues, setInputValues] = useState({
    email: "",
    otp: "",
    comment: "",
  });
  const [err, setErr] = useState({    

    otp: "",
    email: "",
  });

  const handleInputChange = (event) => {
    const target = event.target;
    const value =
      target.type === "checkbox" || target.type === "radio"
        ? target.checked
        : target.value;
    const name = target.name;
    setInputValues((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  function isValidEmail(value) {
    // Use a regular expression to validate the email format
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(value);
  }


  const requestRSVPOTP = async (event) => {
    event.preventDefault(); // Prevent page refresh

    // console.log('props.to', props.to);
    // return

    try {
      if (!isValidEmail(inputValues.email)) {
        setErr({
          otp: '',
          email: "Invalid email address"
        })
        return
      }
      setIsSubmitting(true);

      var params = {
        event_id: props.event_id,
        is_guest: 0,
        email: inputValues.email,
      };

      console.log('params', params);


      var response = await request_rsvp_otp(params);
      var res = await response.json();

      console.log('response status', response.status);
      console.log('res', res);

      setIsSubmitting(false);
      if (response.ok) {
        setTempId(res.auth_id);
        // console.log("res.tmp_id", res.tmp_id);
        setInputValues((prevState) => ({
          ...prevState,
          otp: "",
        }));
        setErr((prevState) => ({
          ...prevState,
          otp: "",
          email: "",
        }));
        setDisplayType('otp')

        // return {
        //   status: 'success'
        // }
      } else {
        if (response.status === 500) {
          toast.error(res.message || "Internal server error", {
            position: "top-center",
            autoClose: 15000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
            zIndex: 1000,
          });
        } else {
          toast.error(res.message || "Something went wrong", {
            position: "top-center",
            autoClose: 15000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
            zIndex: 1000,
          });
        }
        setIsSubmitting(false);
      }
    } catch (error) {
      toast.error("Something went wrong. Error: " + error.message, {
        position: "top-center",
        autoClose: 15000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        zIndex: 1000,
      });
      setIsSubmitting(false);
    }
    return false;
  };

  const verifyOtp = async () => {
    try {
      setIsSubmitting(true);
      var params = {
        auth_id: tempId,
        otp: inputValues.otp,
        email: inputValues.email,
      };

      const res = await verify_rsvp_otp(params)
      const response = await res.json()
      console.log('response', response);
      

      if (res.ok) {
        
        setWithExpiry(
          'rsvp-manager-session-' + props.event_id, 
          response?.session_key ?? '',
          3600000,
        )
        await sleep(2000)
        const rsvpManagerSession = getWithExpiry('rsvp-manager-session-' + props.event_id);
        console.log('AuthRSVPManager rsvpManagerSession', rsvpManagerSession);
        setIsSubmitting(false);
        console.log('props.to', props.to);
        if (props.to.includes('event_id')) {
          navigate(props.to, { replace: true });
        } else {
          navigate(props.to + `?event_id=${props.event_id}`, { replace: true });
        }
        
        // props.setUp()
      } else {
        if (response.status === 500) {
          toast.error(res.message || "Internal server error", {
            position: "top-center",
            autoClose: 15000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
            zIndex: 1000,
          });
        } else {
          toast.error(res.message || "Something went wrong", {
            position: "top-center",
            autoClose: 15000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
            zIndex: 1000,
          });
        }
        setIsSubmitting(false);
      }
      

    } catch (error) {
      toast.error("Something went wrong. Error: " + error.message, {
        position: "top-center",
        autoClose: 15000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        zIndex: 1000,
      });
      setIsSubmitting(false);
    }
  }

  try {
    return (
      <div
        className='bg-gray-100 items-center justify-center justify-items-center content-center py-[120px]'
      >
        {
          displayType === 'email-input' && (
            <div
              className=" bg-white rounded-xl p-5 m-4 max-w-[460px] min-w-[380px] lg:p-[30px] align-middle"
            >
              <p className="font-sora text-new-black-500 text-lg font-medium">
                Login to RSVP Manager Area 
              </p>
              <p className="font-sora text-new-black-500 text-sm mt-4">
                Please provide email address.
              </p>

              <input
                type="email"
                value={inputValues.email}
                name="email"
                placeholder="Type your email address"
                onChange={handleInputChange}
                autoComplete="email"
                required
                // className={this.props.is_erred ? "outline-input-field-erred" : (this.state.is_focus ? "outline-input-field-active" : "outline-input-field")}
                // className="input-field"
                className={`formInput mt-4 ${Boolean(err.email.length) ? "border-red-500" : ""
                  }`}
              />

              {Boolean(err.email.length) ? (
                <p className="input-field-err-msg">{err.email}</p>
              ) : null}

              <button
                className="primaryButton w-full mt-[30px]"
                onClick={requestRSVPOTP}
                disabled={isSubmitting}
              >
                {isSubmitting ? 'Submitting...' : 'Submit'}
              </button>
            </div>
          )
        }
        {
          displayType === 'otp' && (
            <div
              className=" bg-white rounded-xl p-5 m-4 max-w-[460px] min-w-[380px] lg:p-[30px] align-middle"
            >
              <p className="font-sora text-new-black-500 text-lg font-medium">Please verify OTP</p>
              <p className="font-sora text-new-black-500 text-sm mt-4">
                Please enter the OTP code that was sent to your email address.
              </p>

              <input
                type="number"
                value={inputValues.otp}
                name="otp"
                placeholder=" Type your OTP code"
                onChange={handleInputChange}
                autoComplete="text"
                required
                className={`formInput mt-5 ${Boolean(err.otp.length) ? "border-red-500" : ""
                  }`}
              />

              {Boolean(err.otp.length) ? (
                <p className="input-field-err-msg">{err.otp}</p>
              ) : null}

              <button
                className="primaryButton w-full mt-[30px]"
                onClick={verifyOtp}
              >
                {isSubmitting ? 'Submitting...' : 'Submit'}
              </button>
            </div>
          )
        }
      </div>
    )
  } catch (error) {
    return (
      <div>
        
      </div>
    )
  }
}
